{
  "getting_ready_page": {
    "message": "Hey, {firstName}! We're just getting everything ready…",
    "timeout_heading": "This is taking longer than usual",
    "timeout_message": "Your workspace is still being set up. Refresh to check again, or contact support if this keeps happening.",
    "timeout_retry": "Refresh",
    "timeout_support": "Contact support"
  }
}
